import React, { useState, useContext, useEffect } from "react";
import {
  Modal,
  List,
  Container,
  Radio,
  Dropdown,
  Button,
  Header
} from "semantic-ui-react";
import { AppStoreContext } from "../stores/AppStore";
import { post } from "../lib/http";
import { ROUTES } from "../stores/routes";
import { GLOBAL_MODALS } from "../stores/modals";
import { trackAction } from "../tracking";
import OnboardingActions from "../tracking/actions";
import "./ModalReminder.css";
import { useWindowSize } from "../hooks/useWindowSize";
import {useTranslation, Trans} from "react-i18next";
const arrayOfHours = Array.apply(null, { length: 12 }).map((_, i) => ({
  key: i + 1,
  value: i + 1,
  text: i + 1
}));
const listContainerStyle = {
  display: "inline-block",
  width: "auto",
  textAlign: "left"
};
const listItemStyle = { lineHeight: "3rem", fontWeight: "500" };
const trackParams = { from: "modal-set-reminder" };

/**
 * Hack, Trans component injects the text into the component as children.
 * The Radio component expects it as an attribute name label.
 * This pure component bridges that differences
 */
const RadioChildrenToLabel = ({children, value, checked, onClick}) => (
  <Radio
    label={children}
    checked={checked}
    value={value}
    onClick={onClick}
  />
)

export default function ModalReminder() {
  const [t] = useTranslation();
  const appStore = useContext(AppStoreContext);
  const [inHours, setInHours] = useState(2);
  const [reminderChoice, setReminderChoice] = useState(1);
  const [isSaving, setIsSaving] = useState(false);

  const windowSize = useWindowSize()
  const isWide = windowSize.width > 400;

  useEffect(() => {
    trackAction(OnboardingActions.ModalRemiderDisplayed)
  }, [])

  const back = () => {
    appStore.globalModal = GLOBAL_MODALS.WHATS_NEXT;
    trackAction(OnboardingActions.global.Click, { ...trackParams, button: "back" });
  };

  const chooseReminder = (_, val) => {
    setReminderChoice(val.value);
    trackAction(OnboardingActions.ReminderSelected);
  };

  const setReminder = () => {
    trackAction(OnboardingActions.global.Click, { ...trackParams, button: "set-reminder" });
    let hours = 0;
    switch (reminderChoice) {
      case 1:
        hours = inHours;
        break;
      case 2:
        hours = 24;
        break;
      case 3:
        hours = 24 * 7;
        break;
      default:
        trackAction(OnboardingActions.ReminderNoReminder);
        appStore.globalModal = GLOBAL_MODALS.NONE;
        appStore.currentRoute = ROUTES.THANK_YOU;
        return;
    }
    let date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);

    setIsSaving(true);
    post("api/setReminder", { date: date.toUTCString() })
      .then(result => {
        setIsSaving(false);
        appStore.globalModal = GLOBAL_MODALS.NONE;
        appStore.reminderDateUTC = result.reminder_date_utc;
        appStore.currentRoute = ROUTES.THANK_YOU;
        trackAction(OnboardingActions.ReminderSet)
      })
      .catch(() => {
        setIsSaving(false);
        appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR;
      });
  };

  return (
    <Modal
      defaultOpen
      closeOnEscape={false}
      closeOnDimmerClick={false}
      dimmer="blurring"
      size="tiny"
    >
      <Modal.Content>
        <Container fluid textAlign="center" style={{ paddingTop: "1rem"}}>
          <Header as={isWide ? "h1" : "h2"} textAlign="center">
            {t("when_to_send_reminder")}
          </Header>
          <p dangerouslySetInnerHTML={{ __html: t("tutorial_header") }} />
          <List style={listContainerStyle}>
            <List.Item style={listItemStyle}>
              <Trans i18nKey="remind_me_in_x_hours">
                <RadioChildrenToLabel
                  checked={reminderChoice === 1}
                  value={1}
                  onClick={chooseReminder}
                >
                remind me in - DO NOT Translate, i18next replaces this
                </RadioChildrenToLabel>
                <Dropdown
                  value={inHours}
                  options={arrayOfHours}
                  onChange={(_, opt) => {
                    setInHours(opt.value);
                    chooseReminder(null, { value: 1 });
                  }}
                  selectOnNavigation={false}
                  scrolling
                  selection
                  compact
                  style={{ margin: "0 0.25em "}}
                />
                <span className="reminder-hour-line-partial">hours - DO NOT Translate</span>
              </Trans>
            </List.Item>
            <List.Item style={listItemStyle}>
              <Radio
                label={t("remind_tmrw")}
                checked={reminderChoice === 2}
                value={2}
                onClick={chooseReminder}
              />
            </List.Item>
            <List.Item style={listItemStyle}>
              <Radio
                label={t("remind_week")}
                checked={reminderChoice === 3}
                value={3}
                onClick={chooseReminder}
              />
            </List.Item>
            <List.Item style={listItemStyle}>
              <Radio
                label={t("do_not_remind")}
                checked={reminderChoice === 4}
                value={4}
                onClick={chooseReminder}
              />
            </List.Item>
          </List>
        </Container>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={back} secondary floated="left" disabled={isSaving}>
          {t("back")}
        </Button>
        <Button
          onClick={setReminder}
          primary
          disabled={isSaving}
          loading={isSaving}
          >
          {t("submit")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
